import { SliderPropsWithDefaults } from "./types";

export const getDecimalPlaces = (num: number) => {
  const numStr = num.toString();

  if (numStr.includes(".")) {
    return numStr.split(".")[1]?.length;
  }

  return 0;
};

export const getIsMarkerInRange = (
  value: [number, number],
  min: number,
  max: number,
  step: number,
  stepIndex: number
) => {
  const markerPosition = step * stepIndex + min;

  if (stepIndex < 0 || markerPosition > max) {
    return false;
  }

  return markerPosition >= value[0] && markerPosition <= value[1];
};

export const getSliderValue = (
  value: number,
  max: number,
  min: number,
  slider: SliderPropsWithDefaults
): number => {
  const valueBounded = Math.max(min, Math.min(max, value));
  const valueStepped = Math.round(valueBounded / slider.step) * slider.step;
  const stepDecimalPlaces = getDecimalPlaces(slider.step);
  const valueDecimaled = valueStepped.toFixed(stepDecimalPlaces);
  return Number(valueDecimaled);
};

export const getSliderValueFromPercent = (
  percent: number,
  max: number,
  min: number,
  slider: SliderPropsWithDefaults
): number => {
  const value = percent * (slider.max - slider.min) + slider.min;
  return Number(getSliderValue(value, max, min, slider));
};

export const getSortedValue = (value: [number, number]): [number, number] => {
  return value.sort((prev, next) => prev - next);
};
